import { render, staticRenderFns } from "./ModuleEdit.vue?vue&type=template&id=64fc3d2e&scoped=true"
import script from "./ModuleEdit.vue?vue&type=script&lang=js"
export * from "./ModuleEdit.vue?vue&type=script&lang=js"
import style0 from "./ModuleEdit.vue?vue&type=style&index=0&id=64fc3d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fc3d2e",
  null
  
)

export default component.exports